import { createFileRoute } from "@tanstack/react-router";
import { AuditPage } from "../features/audit/pages/audit-page";

export const Route = createFileRoute("/audit")({
  component: () => <AuditPage />,
});
